import BaseModel from '../model/BaseModel';
import Feature from './Feature';

export default class Context {
  private feature: Feature;

  constructor(feature: Feature) {
    this.feature = feature;
  }

  public setFeature(feature: Feature) {
    this.feature = feature;
  }

  public read(): BaseModel {
    return this.feature.execute();
  }
}
